import addDays from "date-fns/addDays";
import moment from "moment";
import { getAuthData } from "../../services/AuthService";


export interface iPackingListFilter {
    PackingListNo: string;
    CustomerID: number;
    From: string;
    To: string;
    readonly Reader: string;
}

export class PackingListFilter {
    PackingListNo: string;
    CustomerID: number;
    From: string;
    To: string;
    readonly Reader: string;

    constructor();
    constructor(obj: iPackingListFilter);	
    constructor(obj?: iPackingListFilter) { 
        this.PackingListNo = obj?.PackingListNo ?? "";
        this.CustomerID = obj?.CustomerID ?? 0;
        this.From = moment(obj?.From ?? addDays(new Date(), -7)).format();
        this.To = moment(obj?.To ?? new Date()).format();
        this.Reader = getAuthData()?.userName ?? "";    
    }
}